import { useActiveMember } from 'hooks';
import useSlackClient from './useSlackClient';

export default function useSlackPremiumTrialAccess() {
  const client = useSlackClient();
  const member = useActiveMember();

  function requestAccess() {
    const metaData = `${member.organizationId}`;

    const requestBody = {
      text: metaData,
    };

    return client.post('T025A2121/B05THPK3XUG/8W2uiOeDp9uYoOzB1xpcFDbi', JSON.stringify(requestBody));
  }

  return requestAccess;
}
